import React, { useContext } from "react";
import parse from "html-react-parser";
import { Modal } from "react-bootstrap";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody } from "../../style/default";

const SeeUpdateModal = ({ open, data }) => {
	const { handleOpenModal } = useContext(ModalContext);

	return (
		<Modal
			show={open}
			onHide={handleOpenModal}
			size="lg"
			backdrop="static"
			animation={false}
		>
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Atualização: {data.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<div>
						<h3>Título</h3>
						<div>{data.title}</div>
					</div>
					<div>
						<h3>Conteúdo</h3>
						<div
							style={{
								borderTop: "1px solid #ccc",
								borderBottom: "1px solid #ccc",
							}}
						>
							{parse(data.content)}
						</div>
					</div>
					<div>
						<h3>Data da atualização</h3>
						<div>{data.updateDate}</div>
					</div>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleOpenModal}>Fechar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
};

export { SeeUpdateModal };
